





















import { Component, Vue } from "vue-property-decorator";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Collection from "@/components/Collection.vue";
import Leaderboard from "@/components/Leaderboard.vue";

@Component({
  components: {
    Leaderboard,
    Footer,
    Header,
    Collection,
  },
})
export default class LeaderboardView extends Vue {
  goTo(): void {
    this.$router.push("/stakeGen2");
    window.scrollTo(0, 0);
  }
}
